/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createPi } from '../../factoriesNumber.js';
export var piDependencies = {
  createPi
};